import './_Content.scss';
import { applicationState } from '@/states/applicationState';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Layout } from '@arkas/coreui';
import React from 'react';

const { Content } = Layout;

interface AppContentProps {
  topMenu: boolean;
  isSmallScreen: boolean;
}

/**
 * AppContent Component
 */
const AppContent: React.SFC<AppContentProps> = props => {
  const { children, topMenu, isSmallScreen } = props;
  return (
    <Content
      className={classnames(
        'app-content',
        topMenu && !isSmallScreen && 'has-top-menu'
      )}
    >
      {children}
    </Content>
  );
};

const mapStateToProps = (state: applicationState) => {
  return {
    isSmallScreen: state.appModel.isSmallScreen,
    topMenu: state.appModel.topMenu
  };
};
export default connect(mapStateToProps)(AppContent);
